import LockedIndicator from '../../app/locked-indicator';

export const columnConfig = (componentProps, titleLink, stateCallBack) => [
    {
        dataKey: '',
        type: 'component',
        component: LockedIndicator,
        componentProps,
        width: '3%',
    },
    {
        className: 'table-with-sort--word-break',
        dataKey: 'title',
        formatter: 'mediaItemsTitle',
        link: `${titleLink}`,
        linkKey: 'guid',
        massActionWidth: '19%',
        sortKey: 'title.sortable',
        title: 'Title',
        type: 'link',
        width: '22%',
    },
    {
        dataKey: 'service.serviceName',
        title: 'Service',
        width: '10%',
    },
    {
        dataKey: 'externalNetwork.name',
        title: 'Network',
        width: '14%',
    },
    {
        className: 'table-with-sort--word-break',
        dataKey: 'showName',
        sortKey: 'showName.sortable',
        title: 'Show Name',
        width: '18%',
    },
    {
        dataKey: 'offerings.0.startDate',
        sortKey: 'offerings.startDate',
        title: 'Start Date',
        tooltip: 'Start Date',
        type: 'date',
        width: '10%',
    },
    {
        dataKey: 'lastUpdated',
        title: 'Last Update',
        tooltip: 'Last Updated',
        type: 'date',
        width: '10%',
    },
    {
        addClassToCell: true,
        dataKey: 'state',
        renderRowCallback: stateCallBack,
        title: 'State',
        width: '13%',
    },
];

export default {
    columnConfig,
};
